import React, {useEffect, useState} from "react";

import "./View.css";
import {Header} from "./common/header/Header";
import {SideMenu} from "./common/side-menu/SideMenu";
import {Profile} from "./dashboard/profile/Profile";
import {Account} from "./dashboard/account/Account";
import {FacilitySelect} from "./problems/new-problem/facility/facility-select/FacilitySelect";
import {FacilitySearch} from "./problems/new-problem/facility/facility-search/FacilitySearch";
import {TopicAreaOne} from "./problems/new-problem/topic-area/topic-area-one/TopicAreaOne";
import {TopicAreaTwo} from "./problems/new-problem/topic-area/topic-area-two/TopicAreaTwo";
import {TopicAreaThree} from "./problems/new-problem/topic-area/topic-area-three/TopicAreaThree";
import {TopicAreaFour} from "./problems/new-problem/topic-area/topic-area-four/TopicAreaFour";
import {ProblemOne} from "./problems/new-problem/problem/problem-one/ProblemOne";
import {ProblemTwo} from "./problems/new-problem/problem/problem-two/ProblemTwo";
import {ProblemFour} from "./problems/new-problem/problem/problem-four/ProblemFour";
import {ProblemThree} from "./problems/new-problem/problem/problem-three/ProblemThree";
import {RootCauseOne} from "./problems/new-problem/root-cause/root-cause-one/RootCauseOne";
import {RootCauseTwo} from "./problems/new-problem/root-cause/root-cause-two/RootCauseTwo";
import {Construction} from "./construction/Construction";
import {ProblemSearch} from "./problems/search-problems/problem-search/ProblemSearch";
import {ProblemSearchResults} from "./problems/search-problems/problem-search-results/ProblemSearchResults";
import {TopicAreaTable} from "./admin/topic-area/topic-area-table/TopicAreaTable";
import {TopicAreaCapture} from "./admin/topic-area/topic-area-capture/TopicAreaCapture";
import {IndicatorTable} from "./admin/indicator/indicator-table/IndicatorTable";
import {IndicatorCapture} from "./admin/indicator/indicator-capture/IndicatorCapture";
import {FacilityTable} from "./admin/facility/facility-table/FacilityTable";
import {FacilityCapture} from "./admin/facility/facility-capture/FacilityCapture";
import {ChangeConceptTable} from "./admin/change-concept/change-concept-table/ChangeConceptTable";
import {ChangeConceptCapture} from "./admin/change-concept/change-concept-capture/ChangeConceptCapture";
import {Toaster} from "./common/toaster/Toaster";
import {TrainingTopicCapture} from "./admin/training-topic/training-topic-capture/TrainingTopicCapture";
import {TrainingTopicTable} from "./admin/training-topic/training-topic-table/TrainingTopicTable";
import {StaffMemberCapture} from "./admin/staff-member/staff-member-capture/StaffMemberCapture";
import {StaffMemberTable} from "./admin/staff-member/staff-member-table/StaffMemberTable";
import {ChangeIdeaOne} from "./problems/new-problem/change-idea/change-idea-one/ChangeIdeaOne";
import {ChangeIdeaTwo} from "./problems/new-problem/change-idea/change-idea-two/ChangeIdeaTwo";
import {ChangeIdeaThree} from "./problems/new-problem/change-idea/change-idea-three/ChangeIdeaThree";
import {RootCauseOverview} from "./problems/new-problem/root-cause/root-cause-overview/RootCauseOverview";
import {ChangeIdeaFour} from "./problems/new-problem/change-idea/change-idea-four/ChangeIdeaFour";
import {ChangeIdeaOverview} from "./problems/new-problem/change-idea/change-idea-overview/ChangeIdeaOverview";
import {StaffMemberReport} from "./reports/staff-member-report/StaffMemberReport";
import {PDSAOverview} from "./problems/new-problem/pdsa/pdsa-overview/PDSAOverview";
import {PDSACycle} from "./problems/new-problem/pdsa/pdsa-cycle/PDSACycle";
import {GatesPerspectiveCapture} from "./reports/gates-perspective/gates-perspective-capture/GatesPerspectiveCapture";
import {GatesPerspectiveTable} from "./reports/gates-perspective/gates-perspective-table/GatesPerspectiveTable";
import {ProblemTree} from "./problems/search-problems/problem-tree/ProblemTree";
import {GrantCapture} from "./admin/grant/grant-capture/GrantCapture";
import {GrantTable} from "./admin/grant/grant-table/GrantTable";
import {FacilityReport} from "./reports/facility-report/FacilityReport";
import {HSDReport} from "./reports/hsd-report/HSDReport";
import {TrainingCapture} from "./training/training-capture/TrainingCapture";
import {ChangeIdeaReport} from "./reports/change-idea-report/ChangeIdeaReport";
import {NotificationView} from "./dashboard/notification/NotificationView";
import {MyProblems} from "./problems/my-problems/MyProblems";
import {AppointmentView} from "./dashboard/appointment/AppointmentView";
import {TrainingReport} from "./reports/training-report/TrainingReport";
import {AlertView} from "./dashboard/alert/AlertView";
import {TrainingSearch} from "./training/training-search/TrainingSearch";
import {TrainingGroupCapture} from "./training/training-group-capture/TrainingGroupCapture";
import {TrainingGroupSearch} from "./training/training-group-search/TrainingGroupSearch";
import {ChangePackageSearch} from "./change-package/change-package-search/ChangePackageSearch";
import {ChangePackageView} from "./change-package/change-package-capture/ChangePackageView";
import {ProblemFive} from "./problems/new-problem/problem/problem-five/ProblemFive";

export const View = ({keycloak, context, setContext, setSpinnerText, toolTipsEnabled}) => {
    const [showMenu, setShowMenu] = useState(true);
    const [activeScreen, setActiveScreen] = useState(context.currentScreen);
    const [toasterData, setToasterData] = useState(null);

    const navigateTo = (screenKey) => {
        setContext((prevState) => ({
            ...prevState,
            currentScreen: screenKey,
            viewStack: [...prevState.viewStack, prevState.currentScreen],
        }));
    };

    const navigateBack = () => {
        const lastScreen = context.viewStack.pop();
        setContext((prevState) => ({
            ...prevState,
            currentScreen: lastScreen,
            viewStack: [...context.viewStack],
        }));
    };

    const showToaster = (data) => {
        const title = data.responseStatus;
        const message = data.responseMessage;
        const color = title === "Success" ? "#04b14b" : "#C8242C";
        const borderColor = title === "Success" ? "#017e34" : "#8f1920";

        setToasterData({title, message, color, borderColor});
        setTimeout(() => {
            setToasterData(null);
        }, 3000);
    }

    useEffect(() => {
        window.addEventListener("resize", () => {
            const isMobile = window.innerWidth < 1000;
            if (isMobile) {
                setShowMenu(false);
            } else {
                setShowMenu(true);
            }
        }, false);
    });

    useEffect(() => {
        let screen = screenMap.get(context.currentScreen);
        if (screen === undefined || screen === null) {
            screen = <Construction navigateBack={navigateBack}/>;
        }
        setActiveScreen(screen);
    }, [context]);

    const screenMap = new Map();
    // DASHBOARD SCREENS
    screenMap.set("dashboardProfile", <Profile setContext={setContext}
                                               context={context}
                                               navigateTo={navigateTo}
                                               showToaster={showToaster}
                                               setSpinnerText={setSpinnerText}/>);

    screenMap.set("dashboardAccount", <Account context={context}
                                               setContext={setContext}
                                               showToaster={showToaster}
                                               setSpinnerText={setSpinnerText}/>);

    screenMap.set("notificationView", <NotificationView navigateTo={navigateTo}
                                                        setContext={setContext}
                                                        context={context}
                                                        showToaster={showToaster}
                                                        setSpinnerText={setSpinnerText}
                                                        toolTipsEnabled={toolTipsEnabled}/>);

    screenMap.set("alertView", <AlertView navigateTo={navigateTo}
                                          setContext={setContext}
                                          context={context}
                                          showToaster={showToaster}
                                          setSpinnerText={setSpinnerText}
                                          toolTipsEnabled={toolTipsEnabled}/>);

    screenMap.set("appointmentView", <AppointmentView context={context}
                                                      setContext={setContext}
                                                      navigateTo={navigateTo}
                                                      showToaster={showToaster}
                                                      setSpinnerText={setSpinnerText}
                                                      toolTipsEnabled={toolTipsEnabled}/>)
    // NEW PROBLEM FACILITY SCREENS
    screenMap.set("facilitySelect", <FacilitySelect context={context}
                                                    setContext={setContext}
                                                    navigateTo={navigateTo}
                                                    showToaster={showToaster}
                                                    setSpinnerText={setSpinnerText}/>);

    screenMap.set("facilitySearch", <FacilitySearch context={context}
                                                    setContext={setContext}
                                                    navigateTo={navigateTo}
                                                    navigateBack={navigateBack}
                                                    setSpinnerText={setSpinnerText}
                                                    showToaster={showToaster}/>);
    // NEW PROBLEM TOPIC AREA SCREENS
    screenMap.set("topicAreaOne", <TopicAreaOne context={context}
                                                setContext={setContext}
                                                navigateTo={navigateTo}
                                                navigateBack={navigateBack}
                                                showToaster={showToaster}
                                                setSpinnerText={setSpinnerText}
                                                toolTipsEnabled={toolTipsEnabled}/>);

    screenMap.set("topicAreaTwo", <TopicAreaTwo context={context}
                                                setContext={setContext}
                                                navigateTo={navigateTo}
                                                toolTipsEnabled={toolTipsEnabled}
                                                navigateBack={navigateBack}
                                                showToaster={showToaster}
                                                setSpinnerText={setSpinnerText}/>);

    screenMap.set("topicAreaThree", <TopicAreaThree toolTipsEnabled={toolTipsEnabled}
                                                    context={context}
                                                    setContext={setContext}
                                                    navigateTo={navigateTo}
                                                    navigateBack={navigateBack}
                                                    showToaster={showToaster}
                                                    setSpinnerText={setSpinnerText}/>);

    screenMap.set("topicAreaFour", <TopicAreaFour context={context}
                                                  setContext={setContext}
                                                  navigateTo={navigateTo}
                                                  navigateBack={navigateBack}
                                                  showToaster={showToaster}
                                                  setSpinnerText={setSpinnerText}
                                                  toolTipsEnabled={toolTipsEnabled}/>);
    // NEW PROBLEM PROBLEM SCREENS
    screenMap.set("problemOne", <ProblemOne toolTipsEnabled={toolTipsEnabled}
                                            context={context}
                                            setContext={setContext}
                                            navigateTo={navigateTo}
                                            navigateBack={navigateBack}
                                            showToaster={showToaster}
                                            setSpinnerText={setSpinnerText}/>)

    screenMap.set("problemTwo", <ProblemTwo context={context}
                                            setContext={setContext}
                                            navigateTo={navigateTo}
                                            navigateBack={navigateBack}
                                            toolTipsEnabled={toolTipsEnabled}
                                            showToaster={showToaster}
                                            setSpinnerText={setSpinnerText}/>);

    screenMap.set("problemThree", <ProblemThree context={context}
                                                setContext={setContext}
                                                navigateTo={navigateTo}
                                                navigateBack={navigateBack}
                                                showToaster={showToaster}
                                                setSpinnerText={setSpinnerText}
                                                toolTipsEnabled={toolTipsEnabled}/>);

    screenMap.set("problemFour", <ProblemFour context={context}
                                              setContext={setContext}
                                              navigateTo={navigateTo}
                                              navigateBack={navigateBack}
                                              setSpinnerText={setSpinnerText}
                                              showToaster={showToaster}
                                              toolTipsEnabled={toolTipsEnabled}/>);

    screenMap.set("problemFive", <ProblemFive context={context}
                                              navigateTo={navigateTo}
                                              navigateBack={navigateBack}
                                              setSpinnerText={setSpinnerText}/>);
    // NEW PROBLEM ROOT CAUSE SCREENS
    screenMap.set("rootCauseOverview", <RootCauseOverview context={context}
                                                          setContext={setContext}
                                                          navigateTo={navigateTo}
                                                          setSpinnerText={setSpinnerText}
                                                          showToaster={showToaster}
                                                          toolTipsEnabled={toolTipsEnabled}/>);

    screenMap.set("rootCauseOne", <RootCauseOne context={context}
                                                setContext={setContext}
                                                navigateTo={navigateTo}
                                                navigateBack={navigateBack}
                                                toolTipsEnabled={toolTipsEnabled}
                                                showToaster={showToaster}
                                                setSpinnerText={setSpinnerText}/>);

    screenMap.set("rootCauseTwo", <RootCauseTwo context={context}
                                                setContext={setContext}
                                                navigateTo={navigateTo}
                                                navigateBack={navigateBack}
                                                setSpinnerText={setSpinnerText}
                                                toolTipsEnabled={toolTipsEnabled}
                                                showToaster={showToaster}/>);
    // NEW PROBLEM CHANGE IDEA SCREENS
    screenMap.set("changeIdeaOverview", <ChangeIdeaOverview context={context}
                                                            setContext={setContext}
                                                            navigateTo={navigateTo}
                                                            setSpinnerText={setSpinnerText}
                                                            showToaster={showToaster}
                                                            toolTipsEnabled={toolTipsEnabled}/>);

    screenMap.set("changeIdeaOne", <ChangeIdeaOne toolTipsEnabled={toolTipsEnabled}
                                                  showToaster={showToaster}
                                                  setSpinnerText={setSpinnerText}
                                                  context={context}
                                                  setContext={setContext}
                                                  navigateTo={navigateTo}
                                                  navigateBack={navigateBack}/>);

    screenMap.set("changeIdeaTwo", <ChangeIdeaTwo toolTipsEnabled={toolTipsEnabled}
                                                  context={context}
                                                  setContext={setContext}
                                                  navigateTo={navigateTo}
                                                  navigateBack={navigateBack}
                                                  showToaster={showToaster}
                                                  setSpinnerText={setSpinnerText}/>);

    screenMap.set("changeIdeaThree", <ChangeIdeaThree toolTipsEnabled={toolTipsEnabled}
                                                      context={context}
                                                      setContext={setContext}
                                                      navigateTo={navigateTo}
                                                      navigateBack={navigateBack}
                                                      showToaster={showToaster}
                                                      setSpinnerText={setSpinnerText}/>);

    screenMap.set("changeIdeaFour", <ChangeIdeaFour toolTipsEnabled={toolTipsEnabled}
                                                    context={context}
                                                    setContext={setContext}
                                                    navigateTo={navigateTo}
                                                    navigateBack={navigateBack}
                                                    setSpinnerText={setSpinnerText}
                                                    showToaster={showToaster}/>);
    // NEW PROBLEM PDSA SCREENS
    screenMap.set("PDSAOverview", <PDSAOverview context={context}
                                                setContext={setContext}
                                                navigateTo={navigateTo}
                                                setSpinnerText={setSpinnerText}
                                                showToaster={showToaster}
                                                toolTipsEnabled={toolTipsEnabled}/>);

    screenMap.set("PDSACycle", <PDSACycle context={context}
                                          setContext={setContext}
                                          navigateTo={navigateTo}
                                          setSpinnerText={setSpinnerText}
                                          showToaster={showToaster}
                                          navigateBack={navigateBack}
                                          toolTipsEnabled={toolTipsEnabled}/>);
    // SEARCH PROBLEM SCREENS
    screenMap.set("problemSearch", <ProblemSearch context={context}
                                                  setContext={setContext}
                                                  navigateTo={navigateTo}
                                                  setSpinnerText={setSpinnerText}/>);

    screenMap.set("problemSearchResults", <ProblemSearchResults context={context}
                                                                setContext={setContext}
                                                                navigateTo={navigateTo}
                                                                setSpinnerText={setSpinnerText}
                                                                showToaster={showToaster}/>);

    screenMap.set("problemTree", <ProblemTree context={context}
                                              setContext={setContext}
                                              navigateTo={navigateTo}
                                              setSpinnerText={setSpinnerText}
                                              showToaster={showToaster}/>);
    // MY PROBLEMS SCREENS
    screenMap.set("myProblems", <MyProblems context={context}
                                            setContext={setContext}
                                            setSpinnerText={setSpinnerText}
                                            showToaster={showToaster}
                                            navigateTo={navigateTo}/>);
    // TRAINING SCREENS
    screenMap.set("trainingCapture", <TrainingCapture context={context}
                                                      showToaster={showToaster}
                                                      setSpinnerText={setSpinnerText}
                                                      navigateTo={navigateTo}
                                                      navigateBack={navigateBack}/>);

    screenMap.set("trainingSearch", <TrainingSearch context={context}
                                                    setContext={setContext}
                                                    navigateTo={navigateTo}
                                                    navigateBack={navigateBack}
                                                    showToaster={showToaster}
                                                    setSpinnerText={setSpinnerText}/>);

    screenMap.set("trainingGroupCapture", <TrainingGroupCapture context={context}
                                                                setContext={setContext}
                                                                navigateTo={navigateTo}
                                                                navigateBack={navigateBack}
                                                                showToaster={showToaster}
                                                                setSpinnerText={setSpinnerText}/>);

    screenMap.set("trainingGroupSearch", <TrainingGroupSearch context={context}
                                                              setContext={setContext}
                                                              navigateTo={navigateTo}
                                                              navigateBack={navigateBack}
                                                              showToaster={showToaster}
                                                              setSpinnerText={setSpinnerText}/>);
    // CHANGE PACKAGE SCREENS
    screenMap.set("changePackageSearch", <ChangePackageSearch context={context}
                                                              setContext={setContext}
                                                              showToaster={showToaster}
                                                              setSpinnerText={setSpinnerText}
                                                              navigateTo={navigateTo}
                                                              navigateBack={navigateBack}/>);

    screenMap.set("changePackageView", <ChangePackageView context={context}
                                                          setContext={setContext}
                                                          navigateTo={navigateTo}
                                                          navigateBack={navigateBack}
                                                          showToaster={showToaster}
                                                          setSpinnerText={setSpinnerText}/>);

    // ADMIN STAFF MEMBERS SCREEN
    screenMap.set("staffMemberCapture", <StaffMemberCapture context={context}
                                                            navigateTo={navigateTo}
                                                            navigateBack={navigateBack}
                                                            showToaster={showToaster}
                                                            setSpinnerText={setSpinnerText}/>);

    screenMap.set("staffMemberTable", <StaffMemberTable context={context}
                                                        setContext={setContext}
                                                        navigateTo={navigateTo}
                                                        showToaster={showToaster}
                                                        setSpinnerText={setSpinnerText}/>);
    // ADMIN GRANT SCREEN
    screenMap.set("grantTable", <GrantTable context={context}
                                            setContext={setContext}
                                            navigateTo={navigateTo}
                                            showToaster={showToaster}
                                            setSpinnerText={setSpinnerText}/>);

    screenMap.set("grantCapture", <GrantCapture context={context}
                                                setContext={setContext}
                                                navigateTo={navigateTo}
                                                navigateBack={navigateBack}
                                                showToaster={showToaster}
                                                setSpinnerText={setSpinnerText}/>);
    // ADMIN TOPIC AREAS SCREEN
    screenMap.set("topicAreaTable", <TopicAreaTable context={context}
                                                    setContext={setContext}
                                                    navigateTo={navigateTo}
                                                    showToaster={showToaster}
                                                    setSpinnerText={setSpinnerText}/>);

    screenMap.set("topicAreaCapture", <TopicAreaCapture context={context}
                                                        navigateTo={navigateTo}
                                                        navigateBack={navigateBack}
                                                        showToaster={showToaster}
                                                        setSpinnerText={setSpinnerText}/>);
    // ADMIN INDICATORS SCREEN
    screenMap.set("indicatorTable", <IndicatorTable context={context}
                                                    setContext={setContext}
                                                    navigateTo={navigateTo}
                                                    showToaster={showToaster}
                                                    setSpinnerText={setSpinnerText}/>);

    screenMap.set("indicatorCapture", <IndicatorCapture context={context}
                                                        navigateTo={navigateTo}
                                                        navigateBack={navigateBack}
                                                        showToaster={showToaster}
                                                        setSpinnerText={setSpinnerText}/>);
    // ADMIN CHANGE CONCEPTS SCREEN
    screenMap.set("changeConceptTable", <ChangeConceptTable context={context}
                                                            setContext={setContext}
                                                            showToaster={showToaster}
                                                            setSpinnerText={setSpinnerText}
                                                            navigateTo={navigateTo}/>);

    screenMap.set("changeConceptCapture", <ChangeConceptCapture context={context}
                                                                navigateTo={navigateTo}
                                                                navigateBack={navigateBack}
                                                                showToaster={showToaster}
                                                                setSpinnerText={setSpinnerText}/>);
    //ADMIN TRAINING TOPICS SCREEN
    screenMap.set("trainingTopicTable", <TrainingTopicTable context={context}
                                                            setContext={setContext}
                                                            navigateTo={navigateTo}
                                                            showToaster={showToaster}
                                                            setSpinnerText={setSpinnerText}/>);

    screenMap.set("trainingTopicCapture", <TrainingTopicCapture context={context}
                                                                navigateTo={navigateTo}
                                                                navigateBack={navigateBack}
                                                                showToaster={showToaster}
                                                                setSpinnerText={setSpinnerText}/>);
    //ADMIN FACILITIES SCREEN
    screenMap.set("facilityTable", <FacilityTable context={context}
                                                  setContext={setContext}
                                                  navigateTo={navigateTo}
                                                  showToaster={showToaster}
                                                  setSpinnerText={setSpinnerText}/>);

    screenMap.set("facilityCapture", <FacilityCapture context={context}
                                                      navigateTo={navigateTo}
                                                      navigateBack={navigateBack}
                                                      showToaster={showToaster}
                                                      setSpinnerText={setSpinnerText}/>);
    // REPORT SCREENS
    screenMap.set("facilityReport", <FacilityReport username={context.username}/>);

    screenMap.set("hsdReport", <HSDReport username={context.username}/>);

    screenMap.set("changeIdeaReport", <ChangeIdeaReport username={context.username}/>);

    screenMap.set("staffMemberReport", <StaffMemberReport username={context.username}/>);

    screenMap.set("trainingReport", <TrainingReport context={context}
                                                    setSpinnerText={setSpinnerText}
                                                    showToaster={showToaster}/>);
    // GATES SCREENS
    screenMap.set("gatesPerspectiveCapture", <GatesPerspectiveCapture context={context}
                                                                      navigateTo={navigateTo}
                                                                      showToaster={showToaster}
                                                                      setContext={setContext}
                                                                      setSpinnerText={setSpinnerText}/>);

    screenMap.set("gatesPerspectiveTable", <GatesPerspectiveTable context={context}
                                                                  setContext={setContext}
                                                                  navigateTo={navigateTo}
                                                                  showToaster={showToaster}
                                                                  setSpinnerText={setSpinnerText}/>);

    return (
        <div className="view-container">
            <Header context={context} setContext={setContext} navigateTo={navigateTo} setShowMenu={setShowMenu}
                    keycloak={keycloak}/>
            <div className="view-content">
                <SideMenu showMenu={showMenu} context={context} navigateTo={navigateTo} setContext={setContext}/>
                <div className={"view-active-screen-content " + (!showMenu ? "center" : null)}>
                    {activeScreen}
                    {toasterData &&
                    <Toaster title={toasterData.title} message={toasterData.message} color={toasterData.color}
                             borderColor={toasterData.borderColor}/>}
                </div>
            </div>
        </div>
    );
}
